import type { ReactNode } from 'react';
import { BotaoAjuda } from '../../features/ajuda/BotaoAjuda';
import { cn } from '../../lib/cn';

/** Cabeçalho padrão das telas: título, descrição e ações à direita. */
export function CabecalhoPagina({
  titulo,
  descricao,
  acoes,
  ajuda,
}: {
  titulo: string;
  descricao?: string;
  acoes?: ReactNode;
  /** Trecho da ajuda desta tela ("guia#secao"), aberto pelo botão "Ajuda desta tela" (D-062). */
  ajuda?: string;
}) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <h1 className="text-2xl font-bold text-texto">{titulo}</h1>
          {ajuda && <BotaoAjuda referencia={ajuda} />}
        </div>
        {descricao && <p className="mt-1 max-w-3xl text-texto-suave">{descricao}</p>}
      </div>
      {acoes && <div className="flex flex-wrap gap-2">{acoes}</div>}
    </div>
  );
}

export function ConteudoPagina({
  children,
  largura = 'larga',
}: {
  children: ReactNode;
  largura?: 'estreita' | 'larga';
}) {
  return (
    <div
      className={cn(
        'mx-auto flex flex-col gap-6',
        largura === 'estreita' ? 'max-w-2xl' : 'max-w-6xl',
      )}
    >
      {children}
    </div>
  );
}
